import styles from './LoadingIndicator.module.scss';
import { memo } from 'react';
import classNames from 'classnames';
import { MaterialIcon } from 'components/design/icons';
import type { HTMLAttributes } from 'react';

const LoadingIndicator = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={classNames(styles.overlay, className)} {...props}>
    <MaterialIcon className={styles.icon} icon="autorenew" spin />
  </div>
);

export default memo(LoadingIndicator);
